






















import { Vue, Component, Prop } from "vue-property-decorator";
import { SideBarOption } from "@/controller/side-bar";

@Component
export default class SideBarItemExpandable extends Vue {
  @Prop({ type: Object, default: {} })
  option!: SideBarOption;
}
